<template>
  <div class="container" :style="styles">
    <svg
      version="1.1"
      id="レイヤー_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 240.3 240.4"
      style="enable-background:new 0 0 240.3 240.4;"
      xml:space="preserve"
      :style="svgStyles"
    >
      <title>C3-lab_logo</title>
      <path
        class="st0"
        d="M231.9,127.7c2.7-0.8,5.5-1.1,8.3-1.1c0.1-1.2,0.1-2.4,0.1-3.5c-3,1.2-5.9,2.6-8.5,4.4c-0.1,0.1-0.1,0.1,0,0.2
    C231.8,127.7,231.8,127.7,231.9,127.7z"
      />
      <path
        class="st0"
        d="M120.2,0C53.8,0,0,53.8,0,120.2c0,0.5,0,1.1,0,1.6c0.9,65,54.1,118,119.1,118.6c14.8,0.1,29.5-2.5,43.4-7.7
    c-11.2-14.5-48.8-71.5-48.8-71.5l0,0c-0.6-0.7-1.4-0.9-2.3-0.7c-6.9,2.2-35.9,10.9-60.1,5.3c-24-5.5-25.4-39.4-25.4-48.3
    c0-1.3,0.9-2.4,2.1-2.6c12.6-2.5,24.9-6.1,36.8-11c0.9-0.3,1.6-1,1.9-1.8l7.5-16.1c1.2-2.7,3.3-4.9,5.9-6.2
    c18.5-9.3,45.4-6.2,51-5.4l0,0c0.2,0.1,0.3,0.1,0.5,0.1l0.5,0.1c3.5-4.4,7.5-8.3,11.9-11.7l0.8-0.6c4.8-3.6,9.9-6.7,15.3-9.3
    c1.3-0.7,2.7-1.3,4.1-1.8l2.1-0.9l2.1-0.8l2.1-0.8c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.7,0,1,0c1.4,0.2,2.7,0.6,3.9,1.4
    c1.2,0.8,2.3,1.7,3.2,2.8c0.9,1.1,1.8,2.3,2.5,3.5c1.5,2.5,2.7,5.1,3.6,7.9c2,5.3,2.2,11.2,0.7,16.7c-0.8,2.7-2.2,5.2-3.9,7.5
    c-1.8,2.3-3.8,4.3-6.1,6.1c-4.8,3.5-10,6.4-15.6,8.4c-5.6,2.2-11.4,3.9-17.2,5.4c-0.3,0.1-0.4,0.3-0.4,0.6c0.1,0.3,0.3,0.4,0.6,0.4
    c6-1.1,11.9-2.7,17.6-4.8c5.8-2,11.3-4.8,16.3-8.4c0.7-0.5,1.4-1.1,2-1.7c10.6,1.8,29.9,1,31.8,0.9c0,0,0.1,0.1,0,0.1
    c-3.2,3.6-7.2,6.4-11.6,8.1c-0.1,0-0.1,0.2-0.1,0.3c0,0.1,0.1,0.1,0.1,0.1c21.5,2.5,33.8,2.8,36.3,2.8c0.1,0,0.2,0.1,0.2,0.3
    c0,0.1,0,0.1,0,0.1c-3.7,4.8-11.9,8.4-14.6,9.5c-0.1,0-0.2,0.1-0.1,0.3c0,0.1,0.1,0.1,0.2,0.1c6.1,0.1,12.2,0.5,18.2,1.2
    C238.9,52.4,185.6,0.1,120.2,0z"
      />
      <polygon
        class="st0"
        points="143,185.1 154.5,176.5 147.3,167.2 136.8,168.1 "
      />
      <polygon
        class="st0"
        points="180.5,187.4 180.5,177.1 166,171.9 168.5,181.7 "
      />
      <polygon
        class="st0"
        points="167.7,197.3 178.9,210.9 194.1,205.4 178.9,194.6 "
      />
    </svg>
    <span class="text">{{ appName }}</span>
    <span class="text">-</span>
    <span class="text">v{{ appVersion }}</span>
  </div>
</template>

<script>
const COLOR_ON_LIGHT_BG = '#283f68'
const COLOR_ON_DARK_BG = '#fff'

export default {
  props: {
    onDarkBackground: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    appName() {
      return process.env.VUE_APP_NAME
    },
    appVersion() {
      return process.env.VUE_APP_VERSION
    },
    styles() {
      return {
        color: this.onDarkBackground ? COLOR_ON_DARK_BG : COLOR_ON_LIGHT_BG,
      }
    },
    svgStyles() {
      let size
      switch (this.size) {
        case 'small':
          size = 30
          break
      }
      return {
        height: `${size}px`,
        width: `${size}px`,
        fill: this.onDarkBackground ? COLOR_ON_DARK_BG : COLOR_ON_LIGHT_BG,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  line-height: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.text {
  font-size: 0.8rem;
  margin-left: 5px;
  font-family: Consolas, 'Courier New', Courier, Monaco, monospace;
}
</style>
